import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Waypoint } from 'react-waypoint'
import { ScrolledIntoView, EVENTS_LABELS } from 'src/constants/trackingEvents'
import { oneTimeTagEventDispatcher } from 'src/helpers/tagManager'
import { Button, Panel, FormField, Text } from 'src/Components'
import BotHead from 'src/Components/shared/Avatar/BotHeadColored'

import styles from './ShareForm.module.scss'

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.ReferralSection
})

const ShareForm = ({ loading, onSubmit }) => (
  <Panel className={styles.card}>
    <Text element='div' align='center'>
      <BotHead quizzical size='xs' />
    </Text>
    <Panel.Heading className={styles.heading}>
      <FormattedMessage
        id='Homeowner.shareForm.heading'
        defaultMessage='Know someone who could use a Homebot report for their home?'
      />
    </Panel.Heading>
    <Text size='s' align='center' color='quiet'>
      <FormattedMessage
        id='Homeowner.shareForm.subHead'
        defaultMessage='Enter their info and we can send them an invitation.'
      />
    </Text>
    <form className={styles.form} onSubmit={onSubmit}>
      <div className={styles.stackable}>
        <FormField.FirstName required />
        <FormField.LastName required />
      </div>
      <FormField.Email required />

      <Text element='div' align='center'>
        <Button loading={loading} type='submit'>
          <FormattedMessage
            id='Homeowner.shareForm.submitButton'
            defaultMessage='Send Invite'
          />
        </Button>
      </Text>
    </form>
    <Waypoint onEnter={scrollIntoView} bottomOffset='25%'>
      <div />
    </Waypoint>
  </Panel>
)

export default ShareForm
